import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import appcolors from "../../../constants/Colors";
import AboutFees from "../../auth/branchSignupSteps/AboutFees";
import AboutVenue from "../../auth/branchSignupSteps/AboutVenue";
import BusinessLocation from "../../auth/branchSignupSteps/BusinessLocation";
import BusinessPhone from "../../auth/branchSignupSteps/BusinessPhone";
import EnableOnlineBookings from "../../auth/branchSignupSteps/EnableOnlineBookings";
import Information from "../../auth/branchSignupSteps/Information";
import OpeningHours from "../../auth/branchSignupSteps/OpeningHours";
import ShowCase from "../../auth/branchSignupSteps/ShowCase";
import ShowCaseTwo from "../../auth/branchSignupSteps/ShowCaseTwo";
import UpdateVenueImages from "../../auth/branchSignupSteps/UpdateVenueImages";
import VenueImageGuidelines from "../../auth/branchSignupSteps/VenueImageGuidelines";

const stepsList = [
  {
    id: 1,
    name: "Step 1",
    value: "1",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 2,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 3,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 4,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 5,
    name: "",
    isActive: true,
    stepColor: "rgb(116 157 50)",
  },
  {
    id: 6,
    name: "Step 2",
    value: "2",
    isActive: false,
    stepColor: appcolors.primary,
  },
  {
    id: 7,
    name: "",
    isActive: true,
    stepColor: appcolors.primary,
  },
  {
    id: 8,
    name: "",
    isActive: true,
    stepColor: "rgb(92 169 244)",
  },
  {
    id: 9,
    name: "Step 3",
    value: "3",
    isActive: false,
    stepColor: "rgb(31 168 136)",
  },
  {
    id: 10,
    name: "",
    isActive: true,
    stepColor: "rgb(31 168 136)",
  },
  {
    id: 11,
    name: "",
    isActive: true,
    stepColor: "rgb(31 168 136)",
  },
];

const daysss = [
  {
    id: 1,
    name: "Monday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 2,
    name: "Tuesday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 3,
    name: "Wednesday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 4,
    name: "Thursday",
    selected: true,
    startTime: "10:00",
    endTime: "19:00",
  },
  {
    id: 5,
    name: "Friday",
    selected: false,
    startTime: "",
    endTime: "",
  },
  {
    id: 6,
    name: "Saturday",
    selected: false,
    startTime: "",
    endTime: "",
  },
  {
    id: 7,
    name: "Sunday",
    selected: false,
    startTime: "",
    endTime: "",
  },
];

const AddEditBranches = ({
  type,
  handleSelect,
  handleChangeTab,
  currentStep,
  setCurrentStep,
  setInputValues,
  inputValues,
  handleCreateBranch,
}) => {
  useEffect(() => {
    if (!inputValues.timmings || inputValues.timmings.length === 0) {
      setInputValues((prev) => ({ ...prev, timmings: daysss }));
    }
  }, []);

  console.log(inputValues, "inputValuesinputValuesinputValues");

  const handleSelecteTime = (updatedDays) => {
    setInputValues((prev) => ({ ...prev, timmings: updatedDays }));
  };

  return (
    <AppContainer
      primaryHeading={"Add your business info"}
      secondaryHeading={
        "Add key details about your business to display on your online booking profile."
      }
      showBackButton
      handleBack={() => handleChangeTab("branch")}
      childrenProps={{
        sx: {
          padding: { xs: "10px 20px", md: "20px 50px" },
          paddingBottom: "50px !important",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: "800px",
          overflowX: "auto",
          margin: "0 20px",
          justifyContent: "center",
        }}
      >
        {stepsList?.map((stepppp, index) => {
          return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {stepppp.name !== "" ? (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "25px",
                      width: "25px",
                      borderRadius: "50%",
                      background: stepppp.id <= currentStep ? "orange" : "none",
                      border: `2.5px solid ${
                        stepppp.id <= currentStep
                          ? "orange"
                          : "rgb(196 196 196)"
                      }`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: "600",
                        color: stepppp.id <= currentStep ? "white" : "black",
                      }}
                    >
                      {stepppp.value}
                    </Typography>
                  </Box>
                  <Divider
                    sx={{ width: "20px", borderBottomWidth: "medium" }}
                  />
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "15px",
                      width: "15px",
                      borderRadius: "50%",
                      background:
                        stepppp.id <= currentStep
                          ? "orange"
                          : "rgb(196 196 196)",
                    }}
                  ></Box>
                  <Divider
                    sx={{
                      width: "20px",
                      display: stepppp?.id == 11 ? "none" : "block",
                      borderBottomWidth: "medium",
                    }}
                  />
                </>
              )}
            </Box>
          );
        })}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          margin: "8px 10px 15px",
          justifyContent: currentStep > 1 ? "space-between" : "flex-end",
        }}
      >
        {currentStep > 1 && (
          <Box
            sx={{
              border: "2px solid black",
              borderRadius: "10px",
              padding: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() => {
              if (currentStep == 1) {
              } else setCurrentStep(currentStep - 1);
            }}
          >
            <ArrowBackIcon />
          </Box>
        )}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {currentStep < 11 && (
            <Box sx={{ marginRight: "10px" }}>
              <GlobalButton
                variant={"contained"}
                btnText={"Continue"}
                styleProps={{ background: "#fff", color: "black" }}
                handleClickBtn={() => {
                  setCurrentStep(currentStep + 1);
                }}
              />
            </Box>
          )}
        </Box>
      </Box>

      {currentStep == 1 && <Information />}
      {currentStep == 2 && (
        <AboutVenue inputValues={inputValues} setInputValues={setInputValues} />
      )}
      {currentStep == 3 && (
        <BusinessPhone
          inputValues={inputValues}
          setInputValues={setInputValues}
        />
      )}
      {currentStep == 4 && (
        <BusinessLocation
          handleSelect={handleSelect}
          inputValues={inputValues}
        />
      )}
      {currentStep == 5 && (
        <OpeningHours
          selectedDays={inputValues.timmings}
          setSelectedDays={handleSelecteTime}
        />
      )}

      {currentStep == 6 && <ShowCase />}
      {currentStep == 7 && <VenueImageGuidelines />}
      {currentStep == 8 && (
        <UpdateVenueImages
          inputValues={inputValues}
          setInputValues={setInputValues}
        />
      )}

      {currentStep == 9 && <ShowCaseTwo />}
      {currentStep == 10 && <AboutFees />}
      {currentStep == 11 && (
        <EnableOnlineBookings
          type={type}
          setInputValues={setInputValues}
          inputValues={inputValues}
          handleCreateBranch={handleCreateBranch}
        />
      )}
    </AppContainer>
  );
};

export default AddEditBranches;
